import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {formatCurrencyKMBT, formatInteger} from '../../utilities/formatters';

import {TEXT} from '../../utilities/strings';

/**
 *  Return a number formatted as an integer
 *
 *  @example
 *  // In a row Render function
 *  return this.renderRow(NUMBER, FormattedNumber.renderInteger)
 *
 *  // As component
 *  return (
 *    <FormattedNumber
 *      value={12.34}
 *      isCurrency={true}
 *    />
 *  )
 */
export default class FormattedNumber extends Component {

  static propTypes = {
    value: PropTypes.any,
    isCurrency: PropTypes.bool
  };

  static renderCurrency = (value) => (
    <FormattedNumber value={value} isCurrency={true}/>
  )

  static renderInteger = (value) => (
    <FormattedNumber value={value} isCurrency={false}/>
  )

  createAriaLabel = () => {
    const {value, isCurrency} = this.props;

    if (isNaN(value)) {
      return TEXT.suppressed_data
    }

    if (isCurrency) {
      return formatInteger(value) + " Dollars"
    }
    else {
      return formatInteger(value)
    }
  }

  createLabel = () => {
    const {value, isCurrency} = this.props;

    if (isNaN(value)) {
      return TEXT.suppressed_data_abbr
    }

    if (isCurrency) {
      return formatCurrencyKMBT(value)
    }
    else {
      return formatInteger(value)
    }
  }

  render() {
    return (
      <span aria-label={this.createAriaLabel()} children={this.createLabel()}/>
    );
  }
}
